import React from "react";
import { NavLink } from "react-router-dom";
import Usp from "./Usp";
import TwoPhoneSection from "./TwoPhoneSection";
import ThreePhoneCommonMainAction from "./ThreePhoneCommonMainAction";
import TeeRating from "./TeeRating";
import ImageWithDesc from "./ImageWithDesc";
// import bannercol from "../../assets/about/about-img-6.jpg";
// import { useLocation } from "react-router-dom";
const About = () => {
  // const location = useLocation();
  return (
    <div className="about">
      {/* <div className="baner-cont-top">
        <img src={bannercol} alt="" />
        <div className="cont-info">
        <h1>{location.pathname.replace('/', '')}</h1>
        </div>
      </div> */}
      <section className=" img_desc_section">
        <div className="page-width">
          <ImageWithDesc
            srcImg={require("../../assets/about/about.svg").default}
            dataLayout={
              <>
                <p className="text-ops-rg-22-dr-green">
                  Timely Golf will eradicate the curse of “Slow Play” ensuring
                  all golfers can complete their round without being held up
                  because of slow play by their fellow golfers. All rounds will
                  be completed within the timeframe decided as reasonable by
                  their club. It will also provide Golf Clubs with the means to
                  monitor the speed of play and to act quickly to resolve any
                  issues of slow play on the course and once again make the
                  sport we all love pleasurable and fun to play.
                </p>
                <div className="home__section2__right__btn">
                  <NavLink
                    to="/club-detail"
                    target="_self"
                    className="res-btn-primary"
                  >
                    SIGN UP
                  </NavLink>
                  <NavLink
                    to="/contact"
                    target="_self"
                    className="res-btn-ternary"
                  >
                    FAQ'S
                  </NavLink>
                </div>
              </>
            }
          />
        </div>
      </section>

      {/* Two Phone Section */}
      <TwoPhoneSection
        heading="RESOLVE SLOW PLAY WITH TIMELY GOLF"
        show_btn={true}
        btnLayout={
          <div className="home__section2__right__btn">
            <NavLink
              to="/club-detail"
              target="_self"
              className="res-btn-primary"
            >
              SIGN UP
            </NavLink>
            <NavLink to="/contact" target="_self" className="res-btn-secondary">
              CONTACT US
            </NavLink>
          </div>
        }
      />

      {/* Three Phone Section */}
      <ThreePhoneCommonMainAction
        heading={
          <span>
            REVOLUTIONARY <br /> GOLFING APP
          </span>
        }
        imgSrc={require("../../assets/images/pages/home/section_1/home_hero_section.svg").default}
        show_subHeading={true}
      />

      {/* Tee Rating Section */}
      <TeeRating />

      {/* USP Section */}
      <Usp />
    </div>
  );
};

export default About;
